import { FormProvider } from "react-hook-form";
import { useForm } from "react-hook-form";
import { ConfirmActionModal } from "../../components/ConfirmActionModal";
import { ButtonAction } from "../../components/NewButtons";
import {
  useCopyAndSetTimeslotsFromShop,
  useGetShops,
} from "./service/shop-api";
import * as authSelectors from "../auth/authSelectors";
import { useSelector } from "react-redux";
import { SelectInput } from "../../components/forms/inputs/SelectInput";
import { SpinnerBlock } from "../common/Spinner";
import { useParams } from "react-router-dom";
import { getErrorMessage } from "../../error-handler";
import { toastr } from "react-redux-toastr";
import { ActionSpinner } from "../../components/ActionSpinner";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  wordingType: "import" | "overwrite";
};

export const CopyTimeslotsModal = ({ isOpen, onClose, wordingType }: Props) => {
  const { shopId } = useParams<{ shopId: string }>();
  const methods = useForm<{ sourceShopId: string }>();
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );
  const { data: shops, isLoading } = useGetShops(organizationKeyName);
  const {
    mutateAsync: copyTimeslots,
    isLoading: isCopyingTimeslots,
  } = useCopyAndSetTimeslotsFromShop();

  const handleClose = () => {
    methods.reset();
    onClose();
  };

  const onSubmit = async (data: { sourceShopId: string }) => {
    if (!shopId) {
      return;
    }
    try {
      await copyTimeslots({
        organizationKeyName,
        data: { sourceShopId: data.sourceShopId, targetShopId: shopId },
      });
      handleClose();
      toastr.success(
        "Success",
        "Timeslots updated successfully. It will take around 10 seconds before you can see your update."
      );
    } catch (error: any) {
      const errorMessage = getErrorMessage(error);
      toastr.error("Error", errorMessage);
    }
  };

  return (
    <FormProvider {...methods}>
      <ConfirmActionModal
        title={
          wordingType === "import" ? "Import timeslots" : "Overwrite timeslots"
        }
        subtitle="Choose restaurant you want to use timeslots from below"
        isOpen={isOpen}
        onClose={handleClose}
        confirmButton={
          <ButtonAction
            onClick={methods.handleSubmit(onSubmit)}
            disabled={isCopyingTimeslots}
          >
            {isCopyingTimeslots ? <ActionSpinner /> : "Save"}
          </ButtonAction>
        }
      >
        {isLoading || !shops ? (
          <SpinnerBlock />
        ) : (
          <SelectInput
            name="sourceShopId"
            label="Source restaurant"
            options={shops
              ?.filter((shop) => shop.id !== shopId)
              .map((shop) => ({
                label: shop.name,
                value: shop.id,
              }))}
          />
        )}
      </ConfirmActionModal>
    </FormProvider>
  );
};
